import { useTheme } from "@emotion/react";
import { Avatar, Box } from "@mui/material";
import { H3, P } from "../../../components/Typography";
import { FL_MAX_WIDTH } from "../FormRow";

export const AvailabilityRow = ({
  avatarSrc,
  title,
  description,
  control,
  details,
  hidden,
  sx = {},
}) => {
  const theme = useTheme();
  const avatarWidth = avatarSrc ? `calc(44px + ${theme.spacing(2)})` : 0;

  if (hidden) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", ...sx }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          maxWidth: FL_MAX_WIDTH,
        }}
      >
        {!!avatarSrc && (
          <Avatar
            sx={{ width: 44, height: 44, mr: 2 }}
            variant="square"
            src={avatarSrc}
          />
        )}
        <Box sx={{ flexGrow: "2" }}>
          <H3 sx={{ mb: 1 }}>{title}</H3>
          <P>{description}</P>
        </Box>
        {control}
      </Box>
      {details && <Box sx={{ pl: `${avatarWidth}`, mt: 2 }}>{details}</Box>}
    </Box>
  );
};
